import { render, staticRenderFns } from "./RepresentativeItem.vue?vue&type=template&id=3a6eec03&"
import script from "./RepresentativeItem.vue?vue&type=script&lang=js&"
export * from "./RepresentativeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports